import { useState } from "react"

import { ResetPasswordFormFieldValues } from "./types"
import { useLoginService } from "../../providers/LoginService"

export const useSubmitHandler = (executeOnSuccess) => {
  const { resetPassword } = useLoginService()

  const [{ submitting, error, data }, setRequestStatus] = useState<any>({
    submitting: false, data: null, error: null
  })

  const handleSubmit = ({ username }: ResetPasswordFormFieldValues) => {
    const payload = new FormData()
    payload.append("username", username)

    setRequestStatus((prev) => ({ ...prev, submitting: true, error: null }))

    resetPassword(payload)
      .then((result) => {
        setRequestStatus({ submitting: false, data: result.data, error: null })
        executeOnSuccess?.()
      })
      .catch((error) => {
        setRequestStatus((prev) => ({ ...prev, submitting: false, error }))
        console.error(error)
      })
  }

  return { handleSubmit, submitting, error, data }
}
